<span [class]="name()"></span>
